var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_language") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u7247",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-175, -273)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-4",
    transform: "translate(179, 277)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "A",
    fontFamily: "PingFangSC-Semibold, PingFang SC",
    fontSize: 14,
    fontWeight: 500,
    fill: "#0E1C39"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 8,
    y: 16
  }, "A")), /*#__PURE__*/React.createElement("path", {
    d: "M12,24 C18.627417,24 24,18.627417 24,12 C24,5.372583 18.627417,0 12,0 C5.372583,0 0,5.372583 0,12",
    id: "\\u692D\\u5706\\u5F62",
    stroke: "#0E1C39",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    transform: "translate(12, 12) rotate(-90) translate(-12, -12)"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "\\u8DEF\\u5F84-5",
    stroke: "#0E1C39",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "14.1176471 18.3529412 18.3529412 21.8823529 23.2941176 16.9411765"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLanguage);
export default __webpack_public_path__ + "static/media/icon_language.fae491533bedcd71c670b030df555344.svg";
export { ForwardRef as ReactComponent };